import { SheetFooter } from '@/components/ui-library/sheet'
import { cn } from '@/utils'

interface SidesheetFooterProps {
  children: React.ReactNode
  className?: string
}
const SidesheetFooter: React.FC<SidesheetFooterProps> = ({ children, className }) => {
  return (
    <SheetFooter id='modal-footer-container'
      className={cn(
        'sticky bottom-0 z-0 mt-auto flex-shrink-0 w-full bg-white p-4 shadow-[0px_0px_8px_4px_rgba(0,0,0,0.10)]',
        'flex justify-end gap-2 sm:space-x-0',
        '[&>button]:m-0',
        className
      )}>
      {children}
    </SheetFooter>
  )
}

SidesheetFooter.displayName = 'SidesheetFooter'

export default SidesheetFooter